import { render, staticRenderFns } from "./TotalReport.vue?vue&type=template&id=2d73a57f"
import script from "./TotalReport.vue?vue&type=script&lang=ts"
export * from "./TotalReport.vue?vue&type=script&lang=ts"
import style0 from "./TotalReport.vue?vue&type=style&index=0&id=2d73a57f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports